import { c as _c } from "react/compiler-runtime";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/radix/tooltip";
import { GallerySmall } from "@/components/sup/gallery/small";
import { Bed, Compass, ShowerHead } from "lucide-react";
import React from "react";
import { type Configuration } from ".";
type SellerProjectCardProps = {
  config: Configuration;
  isActive?: boolean;
  isShortlisted?: boolean;
  onShortlist?: (propertyId: string) => void;
  isMobileView?: boolean;
};
export const ConfigurationCard = React.memo(function ConfigurationCard(t0) {
  const $ = _c(38);
  const {
    config,
    isActive: t1,
    isMobileView: t2
  } = t0;
  const isActive = t1 === undefined ? true : t1;
  t2 === undefined ? false : t2;
  const {
    price,
    bedrooms,
    bathrooms,
    facing,
    builtupArea,
    basePrice,
    image
  } = config;
  const t3 = `w-full ${!isActive ? "hidden" : ""}`;
  let t4;
  if ($[0] !== image) {
    t4 = <GallerySmall mediaList={[{
      url: image,
      type: "image",
      name: "",
      space: ""
    }]} type="unit" className="h-full" />;
    $[0] = image;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== price) {
    t5 = <div className="text-lg font-semibold">{price}</div>;
    $[2] = price;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== basePrice) {
    t6 = basePrice && <div className="text-sm opacity-90">₹{basePrice}/sqft</div>;
    $[4] = basePrice;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t5 || $[7] !== t6) {
    t7 = <div className="flex-1">{t5}{t6}</div>;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = bedrooms ? `${bedrooms} bed${bedrooms > 1 ? "s" : ""}` : "Studio";
  let t9;
  if ($[9] !== t8) {
    t9 = <div>{t8}</div>;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = builtupArea || "N/A";
  let t11;
  if ($[11] !== t10) {
    t11 = <div className="opacity-90">{t10} sqft</div>;
    $[11] = t10;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t11 || $[14] !== t9) {
    t12 = <div className="text-right text-sm">{t9}{t11}</div>;
    $[13] = t11;
    $[14] = t9;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t12 || $[17] !== t7) {
    t13 = <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 via-black/70 to-transparent text-white p-4 pt-8"><div className="flex items-center justify-between">{t7}{t12}</div></div>;
    $[16] = t12;
    $[17] = t7;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t13 || $[20] !== t4) {
    t14 = <div className="relative aspect-square">{t4}{t13}</div>;
    $[19] = t13;
    $[20] = t4;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== bedrooms) {
    t15 = bedrooms && <Tooltip><TooltipTrigger asChild={true}><div className="flex items-center cursor-help"><Bed className="w-4 h-4 mr-1" /><span>{bedrooms}</span></div></TooltipTrigger><TooltipContent><p>{`${bedrooms} ${bedrooms > 1 ? "Bedrooms" : "Bedroom"}`}</p></TooltipContent></Tooltip>;
    $[22] = bedrooms;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== bathrooms) {
    t16 = bathrooms && <Tooltip><TooltipTrigger asChild={true}><div className="flex items-center cursor-help"><ShowerHead className="w-4 h-4 mr-1" /><span>{bathrooms}</span></div></TooltipTrigger><TooltipContent><p>{`${bathrooms} ${bathrooms > 1 ? "Bathrooms" : "Bathroom"}`}</p></TooltipContent></Tooltip>;
    $[24] = bathrooms;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== facing) {
    t17 = facing && <Tooltip><TooltipTrigger asChild={true}><div className="flex items-center cursor-help"><Compass className="w-4 h-4 mr-1" /><span>{facing.charAt(0).toUpperCase()}</span></div></TooltipTrigger><TooltipContent><p>{`${facing} Facing`}</p></TooltipContent></Tooltip>;
    $[26] = facing;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== t15 || $[29] !== t16 || $[30] !== t17) {
    t18 = <div className="p-4"><div className="flex items-center gap-4 text-gray-600 text-sm mb-3">{t15}{t16}{t17}</div></div>;
    $[28] = t15;
    $[29] = t16;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t14 || $[33] !== t18) {
    t19 = <div><div className="">{t14}{t18}</div></div>;
    $[32] = t14;
    $[33] = t18;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t19 || $[36] !== t3) {
    t20 = <TooltipProvider><div className={t3}>{t19}</div></TooltipProvider>;
    $[35] = t19;
    $[36] = t3;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  return t20;
});